import React from 'react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { typography } from '../../design-system/tokens';

/** Full-screen suspension gate — presentation only. */
export default function SuspensionGate({ suspensionEndsAt, onLeave }) {
  return (
    <div className="min-h-screen bg-black p-6 md:p-12 flex items-center justify-center">
      <Card variant="danger" padding="lg" rounded="3xl" className="w-full max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-500/20 border border-red-500/30 flex items-center justify-center text-4xl mx-auto mb-4">
          ⛔
        </div>
        <h1 className={`${typography.heading} text-white mb-2`}>Account suspended</h1>
        <p className={`${typography.body} mb-6`}>
          You have reached 3 strikes. Your account is suspended for 30 days
          {suspensionEndsAt ? `. Reinstated ${new Date(suspensionEndsAt).toLocaleDateString()}.` : '.'}
        </p>
        <Button variant="secondary" onClick={onLeave}>
          Leave
        </Button>
      </Card>
    </div>
  );
}
